module.exports = __webpack_public_path__ + "img/custom_client_seed_1_ru.1daf6a7c.png";